module.exports = __webpack_public_path__ + "static/media/players-icon.7b38f6f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/players-icon.png
// module id = 231
// module chunks = 0